// extracted by mini-css-extract-plugin
export default {"root":"EditChildModal_root__AkDdd","input-container":"EditChildModal_input-container__SjoW3"};